const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const EmailTemplateBuilderCommand: any = {
    AddSection: `${Backofficebff}/v1/emailtemplating/sections`,
    UpdateSection: `${Backofficebff}/v1/emailtemplating/sections`,
    DeleteSection: `${Backofficebff}/v1/emailtemplating/sections/delete`,
    CreateTemplate: `${Backofficebff}/v1/emailtemplating/templates`,
    DeleteTemplate: `${Backofficebff}/v1/emailtemplating/templates/delete`,
};
